<template>
  <div>
    <b-table-simple head-row-variant="primary" small outlined responsive="sm">
      <template #table-caption>This is a table caption.</template>
      <b-thead>
        <b-tr class="" style="background-color: #dae8f6">
          <b-th>Cost Element</b-th>
          <b-th class="w-64">Base Rate/Kg</b-th>
          <b-th class="w-64">Base Multiplier</b-th>
          <b-th></b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr
          v-for="item in costElementField"
          :key="item.name"
          style="border-bottom: 1px solid #dae8f6"
        >
          <b-td class="td1" style="border-right: solid 1px #dae8f6">{{
            item.name
          }}</b-td>
          <b-td class="td-2-3" style="border-right: solid 1px #dae8f6">{{
            constantValues.base_rate
          }}</b-td>
          <b-td class="td-2-3" style="border-right: solid 1px #dae8f6"
            >{{ item.multiplier }}
            <span @click="selectElement(item)" class="float-right"
              ><img src="@/assets/images/icons/edit-box.svg" alt="" /></span
          ></b-td>
          <b-td style="border-right: solid 1px #dae8f6; align-item: center">
            <tooltip text="Restore Default">
              <span @click="restoreDefault(item)" class="text-center">
                <img src="@/assets/images/icons/refresh.png" alt="" />
              </span>
            </tooltip>
          </b-td>
        </b-tr>

        <b-tr style="border-bottom: 1px solid #dae8f6">
          <b-td colspan="4">
            <div class="my-1">
              <strong>Advanced Settings</strong>
              <span
                @click="advanced = false"
                v-if="advanced"
                class="float-right"
              >
                <img src="@/assets/images/icons/arrow-up.png" alt="" />
              </span>
              <span v-else @click="advanced = true" class="float-right">
                <img src="@/assets/images/icons/down.png" alt="" />
              </span>
            </div>

            <div v-if="advanced" class="mx-0">
              <b-table-simple
                head-row-variant="primary"
                small
                class=""
                responsive="sm"
              >
                <b-thead>
                  <b-tr class="" style="background-color: #dae8f6">
                    <b-th>Cost Element</b-th>
                    <b-th class="w-64">Standard Rate</b-th>
                    <b-th class="w-64">Adjusted Rate</b-th>
                    <b-th></b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr
                    v-for="item in advancedField"
                    :key="item.name"
                    style="border-bottom: 1px solid #dae8f6"
                  >
                    <b-td class="td1" style="border-right: solid 1px #dae8f6">{{
                      item.name
                    }}</b-td>
                    <b-td class="td-2-3" style="border-right: solid 1px #dae8f6"
                      >{{ item.standardRate }}%</b-td
                    >
                    <b-td class="td-2-3" style="border-right: solid 1px #dae8f6"
                      >{{ item.adjustedRate }}%
                      <span
                        @click="selectAdvanceElement(item)"
                        class="float-right"
                        ><img
                          src="@/assets/images/icons/edit-box.svg"
                          alt="" /></span
                    ></b-td>
                    <b-td
                      style="
                        border-right: solid 1px #dae8f6;
                        align-item: center;
                      "
                    >
                      <tooltip text="Restore Default">
                        <span @click="restoreAdjustedRate(item)">
                          <img src="@/assets/images/icons/refresh.png" alt="" />
                        </span>
                      </tooltip>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
    <div class="mt-2">
      <p>
        Good-in-Transit & other necessary insurance shall be taken out by MuleEx
        annually and charged a fixed percentage per booking to recoup the cost
        of insurance.
      </p>
    </div>
    <div class="mt-5">
      <Button text="Cancel" @click="$emit('cancel')" background="white" />
      <Button class="float-right" @click="editBillingSetting()" text="Save" />
    </div>

    <!-- Edit cost element modal -->
    <modal
      v-if="selectedElement"
      @close-modal="editModal = false"
      :showModal="editModal"
      id="editModal"
      width="auto"
    >
      <div class="container">
        <div class="row mt-5">
          <div class="col-md-6">
            <span class="float-left">
              <label
                for="pickup-location"
                style="font-weight: 400; font-size: 12px"
                >Enter {{ selectedElement.name }} Multiplier
              </label>
              <base-input
                style="width: 207px"
                type="text"
                v-model="selectedElement.multiplier"
                name="multiplier"
                placeholder="Enter New Base Multiplier"
                required="true"
                error="Enter New Base Multiplier"
                width="50"
              >
              </base-input>
            </span>
          </div>
          <div class="col-md-6 mt-4">
            <Button
              @click="saveEdit"
              text="Save"
              type="submit"
              class="float-right"
            />
          </div>
        </div>
      </div>
    </modal>

    <!-- Edit advance setting -->
    <modal
      v-if="selectedAdvanceElement"
      @close-modal="editAdvanceModal = false"
      :showModal="editAdvanceModal"
      id="editAdvanceModal"
      width="auto"
    >
      <div class="container">
        <div class="row mt-5">
          <div class="col-md-6">
            <span class="float-left">
              <label
                for="pickup-location"
                style="font-weight: 400; font-size: 12px"
                >Enter {{ selectedAdvanceElement.name }} Adjusted Rate
              </label>
              <base-input
                style="width: 207px"
                type="text"
                v-model="selectedAdvanceElement.adjustedRate"
                name="multiplier"
                placeholder="Enter New Base Multiplier"
                required="true"
                error="Enter New Adjusted Rate"
                width="50"
              >
              </base-input>
            </span>
          </div>
          <div class="col-md-6 mt-4">
            <Button
              :loading="loading"
              @click="saveAdvanceEdit"
              text="Save"
              type="submit"
              class="float-right"
            />
          </div>
        </div>
      </div>
    </modal>

    <!-- view selected route modal -->
    <modal
      @close-modal="viewAllRoutes = false"
      :showModal="viewAllRoutes"
      id="selectRoute"
      width="21.9"
    >
      <div>
        <h4 class="font-weight-bold">Selected Route</h4>
        <div class="mx-2">
          <div class="my-2">
            <b-form-group>
              <template v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group
                  id="routes"
                  v-model="selectedRoute"
                  :options="selectedRoute"
                  :aria-describedby="ariaDescribedby"
                  name="routes"
                  class=""
                  aria-label="Individual routes"
                  stacked
                ></b-form-checkbox-group>
              </template>
            </b-form-group>
          </div>
          <div class="my-3">
            <Button
              @click="viewAllRoutes = false"
              class="mr-1 border border-black"
              text=" close"
              background="white"
            />
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import Modal from "@/components/UI/Modal/index.vue";
import Tooltip from "../../Tooltip.vue";

import Button from "@/components/UI/BaseButton.vue";
export default {
  props: ["selectedRoute", "route"],
  components: {
    Button,
    Modal,
    Tooltip,
  },
  data() {
    return {
      shippingServices: [],
      selected: [],
      allSelected: true,
      editModal: false,
      editAdvanceModal: false,
      selectedElement: null,
      selectedAdvanceElement: null,
      costElementField: [
        {
          name: "Gross Weight (Cost Per Kg per Km)",
          baseRate: null,
          payload: "gross_weight_cost_multiplier",
          multiplier: null,
        },
        {
          name: "Volume Weight_Land (Cost Per Kg per Km)",
          baseRate: null,
          payload: "volume_weight_land_cost_multiplier",
          multiplier: null,
        },
        {
          name: "Volume Weight_Air (Cost Per Kg per Km)",
          baseRate: null,
          payload: "volume_weight_air_cost_multiplier",
          multiplier: null,
        },
        {
          name: "Volume Weight_Rail (Cost Per Kg per Km)",
          baseRate: null,
          payload: "volume_weight_rail_cost_multiplier",
          multiplier: null,
        },
        {
          name: "Volume Weight_Sea (Cost Per Kg per Km)",
          baseRate: null,
          payload: "volume_weight_sea_cost_multiplier",
          multiplier: null,
        },
      ],
      advancedField: [
        {
          name: "Fragility",
          standardRate: 15,
          payload: "fragile",
          adjustedRate: null,
        },
        {
          name: "Inflammable",
          standardRate: 25,
          payload: "imflammable",
          adjustedRate: null,
        },
        {
          name: "Radioactive",
          standardRate: 25,
          payload: "radioactive",
          adjustedRate: null,
        },
        {
          name: "Oversized",
          standardRate: 20,
          payload: "oversized",
          adjustedRate: null,
        },
        {
          name: "Overweight",
          standardRate: 10,
          payload: "overweight",
          adjustedRate: null,
        },
        {
          name: "Packaging & Handling",
          standardRate: 10,
          payload: "packageHandling",
          adjustedRate: null,
        },
      ],
      constantValues: [],
      indeterminate: false,

      viewAllRoutes: false,

      advanced: false,
      fields: [
        {
          label: "Cost Element",
          key: "cost",
        },
        {
          label: "Base Rate/Kg",
          key: "rate",
        },
        {
          label: "Base Multiplier",
          key: "multiplier",
        },
      ],
      items: [
        {
          rate: 40,
          multiplier: 40,
          cost: "Dickerson",
        },
        {
          rate: 40,
          multiplier: 40,
          cost: "Dickerson",
        },
        {
          rate: 40,
          multiplier: 40,
          cost: "Dickerson",
        },
        {
          rate: 40,
          multiplier: 40,
          cost: "Dickerson",
        },
        {
          rate: 40,
          multiplier: 40,
          cost: "Dickerson",
        },
      ],
    };
  },
  computed: {},
  mounted() {
    this.getRates();
    this.getData();
    this.getAdvanceData();
    this.getAllRoutes();
  },
  methods: {
    restoreDefault(item) {
      item.multiplier = 1;
    },
    restoreAdjustedRate(item) {
      item.adjustedRate = this.constantValues[item.payload];
      item.adjustedRate = this.selectedAdvanceElement.adjustedRate;
      this.route[this.selectedElement.payload] =
        this.selectedElement.adjustedRate;
    },
    saveEdit() {
      let index = this.costElementField.findIndex(
        (el) => el.payload === this.selectedElement.payload
      );
      this.costElementField[index].multiplier = this.selectedElement.multiplier;
      this.route[this.selectedElement.payload] =
        this.selectedElement.multiplier;
      this.editModal = false;
    },
    saveAdvanceEdit() {
      let index = this.advancedField.findIndex(
        (el) => el.payload === this.selectedAdvanceElement.payload
      );
      this.advancedField[index].adjustedRate =
        this.selectedAdvanceElement.adjustedRate;
      this.route[this.selectedAdvanceElement.payload] =
        this.selectedAdvanceElement.adjustedRate;
      this.editAdvanceModal = false;
    },
    getData() {
      for (let index = 0; index < this.costElementField.length; index++) {
        const element = this.costElementField[index];
        this.costElementField[index].multiplier = this.route[element.payload];
      }
    },
    async getAllRoutes(params) {
      try {
        let response = await this.$_getAllRoutes(params);

        this.shippingServices = response.data.data.shippingServices
          .filter((route) => this.selectedRoute.includes(route.routeName))
          .map((route) => route.id);
      } catch (error) {
        this.handleError(error);
        this.loading = false;
        console.log(error);
      }
    },
    getAdvanceData() {
      for (let index = 0; index < this.advancedField.length; index++) {
        const element = this.advancedField[index];
        this.advancedField[index].adjustedRate = this.route[element.payload];
      }
    },
    selectElement(e) {
      this.selectedElement = { ...e };
      this.editModal = true;
    },
    selectAdvanceElement(e) {
      this.selectedAdvanceElement = { ...e };
      this.editAdvanceModal = true;
    },

    async getRates() {
      try {
        let response = await this.$_getBillingRate();
        this.constantValues = response.data.data.mulexBillingSetting;
      } catch (error) {
        this.handleError(error);
        this.loading = false;
        console.log(error);
      }
    },
    async editBillingSetting() {
      try {
        this.loading = true;
        let orgId = localStorage.getItem("organizationId");
        let userId = localStorage.getItem("userId");
        let payload = {
          shippingServices: this.shippingServices,
          surgeMultipler: this.constantValues.surgeMultipler,
          vat_rate: this.constantValues.vat_rate,
          tran_type: "inter",
          orgId: orgId,
          user_id: userId,
          package_type: "haul",
          fragile: this.route.fragile,
          imflammable: this.route.imflammable,
          radioactive: this.route.radioactive,
          oversized: this.route.oversized,
          overweight: this.route.overweight,
          packageHandling: this.route.packageHandling,
          gross_weight_cost_multiplier: this.route.gross_weight_cost_multiplier,
          volume_weight_land_cost_multiplier:
            this.route.volume_weight_land_cost_multiplier,
          volume_weight_air_cost_multiplier:
            this.route.volume_weight_air_cost_multiplier,
          volume_weight_rail_cost_multiplier:
            this.route.volume_weight_rail_cost_multiplier,
          volume_weight_sea_cost_multiplier:
            this.route.volume_weight_sea_cost_multiplier,
        };

        await this.$_editBillingSetting(payload, this.route.id);
        this.$emit("cancel");
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    toggleAll(checked) {
      this.selected = checked ? this.selectedRoute.slice() : [];
    },
  },
  // watch: {
  //   selectedRoute(newValue) {
  //     if (newValue.length === 0) {
  //       this.indeterminate = false;
  //       this.allSelected = false;
  //     } else if (newValue.length === this.) {
  //       this.indeterminate = false;
  //       this.allSelected = true;
  //     } else {
  //       this.indeterminate = true;
  //       this.allSelected = false;
  //     }
  //   },
  // },
};
</script>
<style scoped>
.tooltip-refresh {
  background: white;
}
.td1 {
  min-width: 440px;
  max-width: 440px;
}
.td2-3 {
  min-width: 200px;
  max-width: 200px;
}
</style>
